
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investors/buying",
      function () {
        return require("private-next-pages/investors/buying.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investors/buying"])
      });
    }
  